import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ModuleMode = "review" | "learning";

interface ContentState {
  progress: number;
  revealIndex: number;
  showContinueButton: boolean;
}

const initialState: ContentState = {
  progress: 0,
  revealIndex: 0,
  showContinueButton: true,
};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    updateProgress: (state) => {
      state.progress = state.progress + 1;
    },
    setRevealIndex: (state, action: PayloadAction<number>) => {
      state.revealIndex = action.payload;
    },
    showContinue: (state) => {
      state.showContinueButton = true;
    },
    hideContinue: (state) => {
      state.showContinueButton = false;
    },
    incrementRevealCount: (state) => {
      state.revealIndex = state.revealIndex + 1;
    },
    clear: () => {
      return initialState;
    },
  },
});

export const {
  updateProgress,
  setProgress,
  showContinue,
  hideContinue,
  incrementRevealCount,
  setRevealIndex,
  clear,
} = contentSlice.actions;

export default contentSlice.reducer;
